"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _Popover = _interopRequireDefault(require("@eig-builder/core-ui/Popover"));

var _defaultSuggestion = _interopRequireDefault(require("../views/default-suggestion"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: auto;\n  min-height: 40px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CreateButton = (0, _styledComponents["default"])(_Button["default"])(_templateObject()); // Render suggestion  list

var RenderSuggestions = function RenderSuggestions(_ref) {
  var getItemProps = _ref.getItemProps,
      toggleMenu = _ref.toggleMenu,
      inputValue = _ref.inputValue,
      handleAddingNewItem = _ref.handleAddingNewItem,
      showAddNewButton = _ref.showAddNewButton,
      handleOnAddNew = _ref.handleOnAddNew,
      noItemFoundText = _ref.noItemFoundText,
      ListItem = _ref.ListItem,
      filteredSuggestions = _ref.filteredSuggestions,
      isOpen = _ref.isOpen,
      highlightedIndex = _ref.highlightedIndex,
      selectedItem = _ref.selectedItem,
      dataToLabelsMapping = _ref.dataToLabelsMapping,
      dataElementSuffix = _ref.dataElementSuffix,
      addNewItemtext = _ref.addNewItemtext,
      inputRef = _ref.inputRef;
  var width = 0;

  if (inputRef) {
    width = inputRef.offsetWidth;
  }

  if (!isOpen) {
    return null;
  }

  return _react["default"].createElement(_Popover["default"], {
    open: true,
    disableAutoFocus: true,
    disableEnforceFocus: true,
    anchorEl: inputRef,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    PaperProps: {
      style: {
        marginTop: 0,
        maxHeight: '250px',
        overflow: 'hidden',
        overflowY: 'scroll',
        width: width + 10
      },
      square: true
    }
  }, filteredSuggestions.map(function (suggestion, index) {
    var props = {
      suggestion: suggestion,
      index: index,
      itemProps: getItemProps({
        item: suggestion
      }),
      highlightedIndex: highlightedIndex,
      selectedItem: selectedItem,
      dataToLabelsMapping: dataToLabelsMapping,
      dataElementSuffix: dataElementSuffix // See if the developer passed their own list item to use.

    };

    if (ListItem) {
      return _react["default"].createElement(ListItem, props);
    } // Else we resort to default


    return (0, _defaultSuggestion["default"])(props);
  }), filteredSuggestions.length === 0 && noItemFoundText && !handleOnAddNew ? ListItem ? _react["default"].createElement(ListItem, {
    suggestion: null,
    noItemFoundText: noItemFoundText
  }) : (0, _defaultSuggestion["default"])({
    suggestion: null,
    noItemFoundText: noItemFoundText
  }) : null, showAddNewButton ? _react["default"].createElement(CreateButton, {
    fullWidth: true,
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      handleAddingNewItem(inputValue);
      toggleMenu();
    }
  }, addNewItemtext ? addNewItemtext(inputValue) : "+ ".concat(inputValue)) : '');
};

RenderSuggestions.propTypes = {
  getItemProps: _propTypes["default"].any,
  toggleMenu: _propTypes["default"].any,
  inputValue: _propTypes["default"].any,
  handleAddingNewItem: _propTypes["default"].any,
  showAddNewButton: _propTypes["default"].any,
  handleOnAddNew: _propTypes["default"].any,
  noItemFoundText: _propTypes["default"].any,
  ListItem: _propTypes["default"].any,
  filteredSuggestions: _propTypes["default"].any,
  isOpen: _propTypes["default"].any,
  highlightedIndex: _propTypes["default"].any,
  selectedItem: _propTypes["default"].any,
  dataToLabelsMapping: _propTypes["default"].any,
  dataElementSuffix: _propTypes["default"].any,
  addNewItemtext: _propTypes["default"].any,
  inputRef: _propTypes["default"].any
};
var _default = RenderSuggestions;
exports["default"] = _default;